// extracted by mini-css-extract-plugin
module.exports = {"chat":"styles_chat__bv11K","inputDescription":"styles_inputDescription__3qHQI"};